import { render, staticRenderFns } from "./StockPicking.vue?vue&type=template&id=23a45dda&scoped=true&"
import script from "./StockPicking.vue?vue&type=script&lang=js&"
export * from "./StockPicking.vue?vue&type=script&lang=js&"
import style0 from "./StockPicking.vue?vue&type=style&index=0&id=23a45dda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a45dda",
  null
  
)

export default component.exports